import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import focusDropdownSearch from 'scaleflow/utils/focus-dropdown-search';
import nameSort from 'scaleflow/utils/nameSort';
import valIsObject from 'scaleflow/utils/is-object';

export default class DropdownsUsersComponent extends Component {
  @service store;
  @tracked tippyInstance = null;
  @tracked textFilter = null;

  get ComponentName() {
    return this.args?.tippy ? 'Tippy' : 'empty-component';
  }

  get valueIds() {
    const isObject = valIsObject(this.args.values);
    const values =
      (isObject
        ? 'promise' in this.args.values
          ? this.args.values?.content
          : this.args.values
        : this.args.values) ?? [];
    return values.map?.((item) => item.id) ?? [];
  }

  get trigger() {
    return this.args?.trigger ?? '';
  }

  get placement() {
    return this.args.placement ?? 'top';
  }

  get interactive() {
    return this.args.interactive ?? false;
  }
  get appendTo() {
    return this.args.appendTo ?? 'parent';
  }

  get searchable() {
    const users = this.store.peekAll('person');
    return users.length > 6;
  }

  get userList() {
    const users = this.store
      .peekAll('person')
      .filter((person) => person.active);
    const list = !this.textFilter
      ? users
      : users.filter(
          (item) =>
            item.name.toLowerCase().indexOf(this.textFilter.toLowerCase()) >= 0,
        );
    let assigneesList = [];
    let othersList = [];
    list.slice().forEach((item) => {
      if (this.valueIds.includes(item.id)) {
        assigneesList.push(item);
      } else {
        othersList.push(item);
      }
    });
    assigneesList = assigneesList.sort((a, b) => nameSort(a.name, b.name));
    othersList = othersList.sort((a, b) => nameSort(a.name, b.name));
    return {
      assignees: assigneesList,
      others: othersList,
    };
  }

  get personsList() {
    return this.store.peekAll('person');
  }

  @action
  handleSearch(text) {
    this.textFilter = text;
  }

  @action
  async handleCheckboxToggle(item, e) {
    let values = (await this.args.values) ?? [];
    if (e.target.checked) {
      values.push(item);
    } else {
      values = values.filter((_item) => _item.id !== item.id);
    }
    this.args?.onSelect?.(values);
  }

  @action
  onShown(instance) {
    focusDropdownSearch(instance);
  }

  @action
  handleUserClick(item) {
    this.args?.handleUserSelect(item);
  }

  get isMultiselect() {
    return Boolean(this.args?.multiselect) == true;
  }

  @action
  setTippyInstance(instance) {
    this.tippyInstance = instance;
  }

  @action
  handleAddPerson() {
    this.args?.onAddPersonClick?.();
  }

  willDestroy() {
    this.tippyInstance?.destroy?.();
    this.tippyInstance = null;
    this.textFilter = null;
    super.willDestroy(...arguments);
  }
}
